// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title[data-v-7d7ec78d] {\n  width: 100%;\n  font-size: 16px;\n  font-weight: bold;\n}\n.name[data-v-7d7ec78d] {\n  font-size: 16px;\n}\n.name span[data-v-7d7ec78d] {\n  font-size: 14px;\n  margin-left: 10px;\n  cursor: pointer;\n  color: #1890ff;\n  font-weight: bold;\n}\n.ant-checkbox-wrapper[data-v-7d7ec78d] {\n  margin-top: 10px;\n}", ""]);
// Exports
module.exports = exports;
